module.exports = __webpack_public_path__ + "static/media/Herdier_gaussian2.9bcdd3b9.png";